import React, {Component, RefObject} from "react"
import Styles from "./input.less"

interface InputFieldProps {
    isActive?: boolean
    onInputChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
    value: string
    defaultValue?: string
    onKeyDown: (e: any) => void
    onCompositionChange: (e: boolean) => void
}

interface InputFieldState {
    value: string
    textAreaHeight: number
}

// eslint-disable-next-line react/no-unsafe
class InputField extends Component<InputFieldProps & React.InputHTMLAttributes<HTMLTextAreaElement>, InputFieldState> {
    constructor(props: InputFieldProps) {
        super(props)
        this.state = {
            value: this.props.value || this.props.defaultValue || "",
            textAreaHeight: 20,
        }
        this.isOnComposition = false
        this.emittedInput = true
        this.inputRef = React.createRef()
        this.preRef = React.createRef()
        this.textAreaHeight = 20
    }

    componentDidMount(): void {
        this.inputRef.current?.addEventListener("keydown", this.handleKeyDown)
        this.textAreaHeight = this.preRef.current?.offsetHeight ? this.preRef.current?.offsetHeight : 20
        this.focusInput()
    }

    UNSAFE_componentWillReceiveProps(
        nextProps: Readonly<InputFieldProps & React.InputHTMLAttributes<HTMLTextAreaElement>>
    ): void {
        const {value} = nextProps
        if (value !== this.props.value) {
            this.setState({
                value,
            })
        }
        if (nextProps.isActive) {
            this.focusInput()
        }
    }

    componentWillUnmount(): void {
        this.inputRef.current?.removeEventListener("keydown", this.handleKeyDown)
    }

    focusInput = () => {
        this.inputRef.current?.focus()
    }

    handleKeyDown = (e: KeyboardEvent): void => {
        this.props.onKeyDown(e)
        // if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        //     e.preventDefault()
        // }
        if (e.key === "Enter") {
            e.preventDefault()
        }
    }

    private isOnComposition: boolean
    private emittedInput: boolean
    private textAreaHeight: number
    private readonly inputRef: RefObject<HTMLTextAreaElement>
    private readonly preRef: RefObject<HTMLPreElement>

    handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        let userInputValue = event.target.value
        if (userInputValue.length > 3000 && !this.isOnComposition) {
            userInputValue = userInputValue.slice(0, 3000)
            // return
        }
        this.preRef.current!.innerText = userInputValue
        this.setState({
            value: userInputValue.trim(),
        })
        if (!this.isOnComposition) {
            if (userInputValue.length > 3000 && !this.isOnComposition) {
                userInputValue = userInputValue.slice(0, 3000)
                // return
            }
            event.target.value = userInputValue.trim()
            this.props.onInputChange(event)
            this.emittedInput = true
        } else {
            this.emittedInput = false
        }
        // this.props.onChange(userInputValue)
    }
    // compositionEvent 和 ChangeEvent不能互通？？？感觉有点问题
    handleComposition = (event: any): void => {
        if (event.type === "compositionstart") {
            this.isOnComposition = true
            this.emittedInput = false
            this.props.onCompositionChange(true)
        } else if (event.type === "compositionend") {
            this.isOnComposition = false
            this.props.onCompositionChange(false)
            if (!this.emittedInput) {
                this.handleInputChange(event)
            }
        }
    }

    render(): React.ReactNode {
        return (
            <div className={Styles.scrollInputArea}>
                <div className={Styles.inputArea}>
                    <pre ref={this.preRef} className={Styles.pre}>
                        {this.state.value}
                    </pre>
                    <textarea
                        ref={this.inputRef}
                        readOnly={this.props.readOnly}
                        style={{
                            height: this.textAreaHeight,
                        }}
                        value={this.state.value}
                        // alt={"search-input"}
                        placeholder={this.props.placeholder}
                        className={this.props.className}
                        onChange={this.handleInputChange}
                        onCompositionStart={this.handleComposition}
                        onCompositionEnd={this.handleComposition}
                    />
                    {/* <input
                    ref={this.inputRef}
                    readOnly={this.props.readOnly}
                    value={this.state.value}
                    alt={"search-input"}
                    placeholder={this.props.placeholder}
                    className={this.props.className}
                    onChange={this.handleInputChange}
                    onCompositionStart={this.handleComposition}
                    onCompositionEnd={this.handleComposition}
                /> */}
                </div>
            </div>
        )
    }
}

export default InputField
